import {FC} from 'react';
import Dropdown from 'components/Form/Dropdown';
import InputText from 'components/Form/InputText';
import Radio from 'components/Form/Radio';
import Stacked from 'components/Layout/Stacked';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {EmployeeRightsCreateBackendData} from '../types';
import UpgradeMessage from './UpgradeMessage';

type UserLicenseProps = {
    isCreatingNewEmployee?: boolean;
};

const UserLicense: FC<UserLicenseProps> = ({isCreatingNewEmployee}) => {
    const {
        appPermissions: {canEditRights},
        data: {userLicense},
    } = useBackend<EmployeeRightsCreateBackendData>();

    return (
        <>
            {isCreatingNewEmployee && (
                <Stacked className="max-w-lg">
                    <div>
                        <p>
                            {t`You are about to invite this person to join ${userLicense.companyName} on MakeLeaps. Please enter their email address and an email invitation will be sent to this address with a link which can be used to sign up and join your company.`}
                        </p>
                        <p>{t`This person will be able to view the data in your company.`}</p>
                    </div>
                    <InputText
                        label={t`Last name`}
                        name="family_name"
                        required={true}
                    />
                    <InputText
                        label={t`First name`}
                        name="given_name"
                        required={true}
                    />
                    <InputText
                        helpText={t`e.g. name@example.com`}
                        label={t`Email Address`}
                        name="address"
                        required={true}
                    />
                    <Dropdown
                        aria-label={t`Group`}
                        helpText={t`Documents and clients owned by a group are only visible to members of the group`}
                        isMultiChoices={true}
                        label={t`Group`}
                        name="groups"
                        options={userLicense.groups}
                        type="select"
                    />
                </Stacked>
            )}
            <div className="mt-4 flex flex-col gap-4">
                <UpgradeMessage />
                <Radio
                    className="my-4"
                    label={<h2 className="m-0">{t`User License`}</h2>}
                    name="user_license"
                    options={userLicense.options}
                    readOnly={!canEditRights.allowed}
                />
            </div>
        </>
    );
};

export default UserLicense;
